<!-- SIDEBAR — Figma Calm Clinical Design (Node 1967-3173) -->
<aside class="sidebar group flex flex-col" [ngClass]="{ 'collapsed': collapsed, 'mobile-open': mobileSidebarOpen }">

  <!-- ══ FIXED HEADER: Brand / Logo (56px) ═════════════════════════ -->
  <div class="sidebar-header flex items-center">
    <div class="brand-container flex items-center">
      <!-- Brand mark (40px wide, centered at x=32px permanently) -->
      <div class="brand-mark flex-shrink-0 med-surface-active" routerLink="/dashboard" style="cursor:pointer;">
        <!-- Logo is masked so it takes the brand-mark colour (same as the active sidebar icons) -->
        <span class="brand-logo" role="img" aria-label="PSP MedJourney Logo"></span>
      </div>

      <!-- Brand name -->
      <span class="brand" routerLink="/dashboard" style="cursor:pointer;">
        Medjourney
      </span>
    </div>

    <!-- Mobile/Tablet close (< 1024px) -->
    <button type="button"
      class="mobile-close-btn lg:hidden rounded-md p-1.5 text-base flex items-center justify-center w-8 h-8 cursor-pointer border-0 bg-transparent text-[#8FADB2] hover:text-[#182E36] hover:bg-[#F5F8F8] ml-auto"
      (click)="closeMobileSidebar()" aria-label="Close sidebar">✕</button>
  </div>

  <!-- ══ SCROLLABLE NAVIGATION BODY (Only this container scrolls) ══ -->
  <div class="sidebar-scroll flex-1">

    @for (group of groupedMenuItems(); track group.name) {
    <div class="nav-group">
      <!-- Section label -->
      <div class="section-label">{{ group.name }}</div>

      @for (item of group.items; track (item.label + '-' + item.route)) {

      <!-- Expandable parent item -->
      @if (item.children) {
      <div>
        <button type="button" class="menu-item w-full text-left" [class.active]="isParentActive(item)"
          [attr.title]="collapsed ? item.label : null" [style.--delay.ms]="getItemDelay(item.route)"
          (click)="collapsed ? null : toggleExpand(item.route)" (mouseenter)="onParentMouseEnter($event, item)"
          (mouseleave)="onParentMouseLeave()">
          <span class="menu-item-icon">
            <app-icon [name]="item.icon" [size]="18"></app-icon>
          </span>
          <span class="menu-item-text">{{ item.label }}</span>
          <span class="chevron" [class.open]="isExpanded(item.route)">
            <app-icon name="chevronDown" [size]="14"></app-icon>
          </span>
        </button>

        <!-- Inline sub-menu -->
        <div class="submenu-wrap" [class.open]="!collapsed && isExpanded(item.route)">
          <div class="submenu">
            @for (child of item.children; track (child.label + '-' + child.route)) {
            @if (isChildVisible(child)) {
            @if (child.action) {
            <button type="button" class="submenu-item" (click)="onChildAction(child); closeMobileSidebar()">
              <span class="submenu-dot"></span>
              <span>{{ child.label }}</span>
            </button>
            } @else {
            <a [routerLink]="child.route" [queryParams]="child.queryParams" class="submenu-item"
              [class.active]="isChildActive(child)" (click)="closeMobileSidebar()">
              <span class="submenu-dot"></span>
              <span>{{ child.label }}</span>
            </a>
            }
            }
            }
          </div>
        </div>
      </div>
      }

      <!-- Regular item -->
      @else {
      <a [routerLink]="item.route" [class.active]="isMenuItemActive(item.route)"
        [attr.title]="collapsed ? item.label : null" [style.--delay.ms]="getItemDelay(item.route)" class="menu-item"
        (click)="closeMobileSidebar()">
        <span class="menu-item-icon">
          <app-icon [name]="item.icon" [size]="18"></app-icon>
        </span>
        <span class="menu-item-text">{{ item.label }}</span>
      </a>
      }

      }
    </div>
    }

  </div>

  <!-- ══ FIXED BOTTOM FOOTER: Workspace identity card (Pinned at bottom) ══ -->
  <div class="sidebar-footer">
    <div class="workspace-identity med-surface-active">
      <span class="workspace-name">
        {{ authService.currentOrganization()?.name || 'Patient support program' }}
      </span>
      <div class="workspace-status">
        <!-- Shield-check icon -->
        <svg class="workspace-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 2l8 4v6c0 5-4 8-8 9-4-1-8-4-8-9V6l8-4z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
        <span class="workspace-type">Organization workspace</span>
      </div>
    </div>
  </div>

</aside>

<!-- ══ FLYOUT PANEL (fixed, outside sidebar, collapsed mode) ════════ -->
<div *ngIf="collapsed && hoveredItem && hoveredItem.children" class="flyout-panel" [style.top.px]="flyoutTop"
  (mouseenter)="onFlyoutMouseEnter()" (mouseleave)="onFlyoutMouseLeave()">
  <div class="flyout-header">{{ hoveredItem!.label }}</div>
  @for (child of hoveredItem!.children; track (child.label + '-' + child.route)) {
  @if (isChildVisible(child)) {
  @if (child.action) {
  <button type="button" class="flyout-item" (click)="onChildAction(child); closeFlyout(); closeMobileSidebar()">{{
    child.label }}</button>
  } @else {
  <a [routerLink]="child.route" [queryParams]="child.queryParams" class="flyout-item"
    [class.active]="isChildActive(child)" (click)="closeFlyout(); closeMobileSidebar()">{{ child.label }}</a>
  }
  }
  }
</div>

<app-order-booking-modal [isOpen]="showOrderBookingModal"
  (closed)="showOrderBookingModal = false"></app-order-booking-modal>